export class PathPattern {
    private readonly regex: RegExp;
    private readonly pattern: string;

    public constructor(pattern: string) {
        this.pattern = pattern;
        const regexpPattern = pattern
            .split(/[\\\/]/g)
            .map(pathSegment => {
                if (pathSegment === "*") {
                    return "[^\\/\\\\]+?";
                }
                if (pathSegment === "**") {
                    return "(.*?)";
                }
                if (pathSegment.includes("**")) {
                    throw new Error(`InvalidPatter: ${pattern}. Double dots must be in separated path segment`);
                }
                return pathSegment
                    .replace(/\//g, "\\/")
                    .replace(/\./g, "\\.")
                    .replace(/{/g, "(?<")
                    .replace(/\*/g, "[^\\/\\\\]+?")
                    .replace(/}/g, ">[^\\/\\\\]*?)");
            })
            .join("[\\\\\\/]");
        this.regex = new RegExp(regexpPattern);
    }

    public exec(target: string): undefined | { [name: string]: string } {
        const match = this.regex.exec(target);
        if (match == undefined) {
            return undefined;
        }
        return match.groups;
    }

    public execStrict(target: string): { [name: string]: string } {
        const match = this.regex.exec(target);
        if (match == undefined || match.groups == undefined) {
            throw new Error(`Path '${target}' does not match patter ${this.pattern}`);
        }
        return match.groups;
    }
}
